// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.initialization-container,
.initialization-error-container {
  position: relative;
  background-color: black;
  height: 100%;
  width: 100%;
}

.initialization-container .label,
.initialization-error-container .label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 28px;
  text-transform: uppercase;
  font-weight: bold;
}

.image-container-alert {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000000000000000;
}

.image-container-alert .label {
  font-size: 28px;
  font-weight: bold;
  text-transform: uppercase;
}

.initialization-container .label,
.image-container-alert .label {
  color: white;
}

.initialization-error-container .label {
  color: red;
}

.shooting-screen-container {
  height: 100%;
  background-color: black;
  position: relative;
}

.initialization-container button,
.initialization-error-container button,
.shooting-screen-container button {
  z-index: 999;
}

/*.shooting-screen-container .btn-cancel,
.initialization-container .btn-cancel,
.initialization-error-container .btn-cancel {
    top: 10px;
    right: 10px;
}
.shooting-screen-container .btn-enroll {
   top: 10px;
    left: 10px;
}*/
.shade {
  display: flex;
  max-width: 100vw;
  width: 100vw;
  max-height: 100vh;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
}

.shooting-screen-container {
  width: 100%;
}

.shooting-screen-container .image-container {
  width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
  overflow: hidden;
}

.target_container {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  top: 0;
  justify-content: center;
}

.shooting-screen-container .target {
  width: 90%;
}

.shooting-screen-container .fit-to-height {
  height: 100%;
}

.shooting-screen-container .fit-to-width {
  width: 100%;
}

.shooting-screen-container .eye-position-marker {
  position: absolute;
  margin: -15px;
}

.shooting-screen-container .eye-position-parameters {
  position: absolute;
  margin-top: 15px;
  margin-left: 10px;
  font-weight: bold;
  font-size: 13px;
  color: red;
}

.confirmation-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.confirmation-container__header {
  width: 100%;
  padding: 10px;
  flex: none;
  background: whitesmoke;
}

.header .label {
  font-size: 24px;
  font-weight: bold;
}

.photo-list-solo {
  display: flex;
  text-align: center;
  width: 100%;
  padding: 20px;
}

.photo-list-solo__col {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
  justify-content: center;
  text-transform: uppercase;
}

.photo-list-solo .cropped-image {
  margin: 10px;
  width: 70%;
  border-radius: 7px;
  border: #448aff 2px solid;
}

.photo-list-several {
  width: 100%;
  display: flex;
  align-items: center;
}

.photo-list-several__elem {
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  padding: 5px 20px 20px 20px;
  border: 1px solid #e4e8eb;
  text-transform: uppercase;
  border-radius: 9px;
}

.photo-list-several__elem-active {
  border: 1px solid #448aff;
}

.photo-list-several__elem__label {
  display: flex;
  padding: 10px;
}

.photo-list-several__elem__img {
  height: 35vh;
  margin-bottom: 2px;
}

.photo-list-several__lables {
  display: flex;
  flex-direction: column;
  width: 100px;
  height: 100%;
  padding: 20px;
  justify-content: space-evenly;
  text-align: center;
  text-transform: uppercase;
}

.command-line {
  display: flex;
  flex-direction: column;
  width: 80px;
  align-items: center;
  justify-content: space-evenly;
}

.command-line button {
  width: 50px;
}

.rotate {
  transform: rotate(180deg);
  transition: 0.75s;
}

.derotate {
  transform: rotate(0deg);
  transition: 0.75s;
}

.image-container__buttons {
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 98%;
  z-index: 500;
  margin: 0 1%;
}

.image-container__buttons button {
  margin: 10px;
}

.confirmation-container__content {
  display: flex;
  height: 100%;
}

.cam_left__collumn,
.cam_right__collumn {
  background: #f8f8fa;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  padding: 10px;
  align-items: center;
}

.cam_right__collumn-top {
  height: 55%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.image-container {
  box-sizing: border-box;
}

.btn-cancel {
  width: 55px;
  height: 55px;
  background: #e4e8eb;
  border-radius: 7px;
}

.btn-cancel-init {
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
}

.btn-cancel-init button {
  margin: 10px;
}

.confirm_buttons {
  display: flex;
  flex-direction: column;
  height: 150px;
  justify-content: space-between;
  align-items: center;
}

.btn-confirm {
  width: 55px;
  height: 55px;
  background: #448aff;
  border-radius: 7px;
}

.btn-confirm__mark {
  color: white;
}

.light_icon {
  color: #44494e;
}

.light_icon__active {
  color: #448aff;
}

.disable_rotate {
  color: #e4e8eb !important;
}

.image-container {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/tablet-sign-photo-wizard/tablet-sign-photo-wizard.component.scss"],"names":[],"mappings":"AAAA;;EAEI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AACA;;EAEI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AAGJ;;AADA;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;AAIJ;;AAFA;;EAEI,YAAA;AAKJ;;AAHA;EACI,UAAA;AAMJ;;AAJA;EACI,YAAA;EACA,uBAAA;EACA,kBAAA;AAOJ;;AALA;;;EAGI,YAAA;AAQJ;;AANA;;;;;;;;;EAAA;AAUA;EACI,aAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AASJ;;AAPA;EACI,WAAA;AAUJ;;AARA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAWJ;;AATA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,uBAAA;AAYJ;;AAVA;EACI,UAAA;AAaJ;;AAXA;EACI,YAAA;AAcJ;;AAZA;EACI,WAAA;AAeJ;;AAbA;EACI,kBAAA;EACA,aAAA;AAgBJ;;AAdA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;AAiBJ;;AAfA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAkBJ;;AAhBA;EACI,WAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;AAmBJ;;AAjBA;EACI,eAAA;EACA,iBAAA;AAoBJ;;AAlBA;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAqBJ;;AAnBA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;AAsBJ;;AApBA;EACI,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAuBJ;;AArBA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AAwBJ;;AAtBA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAyBJ;;AAvBA;EACI,yBAAA;AA0BJ;;AAxBA;EACI,aAAA;EACA,aAAA;AA2BJ;;AAzBA;EACI,YAAA;EACA,kBAAA;AA4BJ;;AA1BA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;AA6BJ;;AA3BA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;AA8BJ;;AA5BA;EACI,WAAA;AA+BJ;;AA7BA;EACI,yBAAA;EACA,iBAAA;AAgCJ;;AA9BA;EACI,uBAAA;EACA,iBAAA;AAiCJ;;AA/BA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AAkCJ;;AAhCA;EACI,YAAA;AAmCJ;;AAjCA;EACI,aAAA;EACA,YAAA;AAoCJ;;AAlCA;;EAEI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAqCJ;;AAnCA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AAsCJ;;AApCA;EACI,sBAAA;AAuCJ;;AArCA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAwCJ;;AAtCA;EACI,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;AAyCJ;;AAvCA;EACI,YAAA;AA0CJ;;AAxCA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA2CJ;;AAzCA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA4CJ;;AA1CA;EACI,YAAA;AA6CJ;;AA3CA;EACI,cAAA;AA8CJ;;AA5CA;EACI,cAAA;AA+CJ;;AA7CA;EACI,yBAAA;AAgDJ;;AA7CA;EACI,4BAAA;EACA,wBAAA;EACA,2BAAA;AAgDJ","sourcesContent":[".initialization-container,\n.initialization-error-container {\n    position: relative;\n    background-color: black;\n    height: 100%;\n    width: 100%;\n}\n.initialization-container .label,\n.initialization-error-container .label {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    margin: 0;\n    font-size: 28px;\n    text-transform: uppercase;\n    font-weight: bold;\n}\n.image-container-alert {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999999999999999;\n}\n.image-container-alert .label {\n    font-size: 28px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n.initialization-container .label,\n.image-container-alert .label {\n    color: white;\n}\n.initialization-error-container .label {\n    color: red;\n}\n.shooting-screen-container {\n    height: 100%;\n    background-color: black;\n    position: relative;\n}\n.initialization-container button,\n.initialization-error-container button,\n.shooting-screen-container button {\n    z-index: 999;\n}\n/*.shooting-screen-container .btn-cancel,\n.initialization-container .btn-cancel,\n.initialization-error-container .btn-cancel {\n    top: 10px;\n    right: 10px;\n}\n.shooting-screen-container .btn-enroll {\n   top: 10px;\n    left: 10px;\n}*/\n.shade {\n    display: flex;\n    max-width: 100vw;\n    width: 100vw;\n    max-height: 100vh;\n    height: 100vh;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n.shooting-screen-container {\n    width: 100%;\n}\n.shooting-screen-container .image-container {\n    width: 100%;\n    height: 100%;\n    z-index: 100;\n    position: absolute;\n    overflow: hidden;\n}\n.target_container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    position: absolute;\n    top: 0;\n    justify-content: center;\n}\n.shooting-screen-container .target {\n    width: 90%;\n}\n.shooting-screen-container .fit-to-height {\n    height: 100%;\n}\n.shooting-screen-container .fit-to-width {\n    width: 100%;\n}\n.shooting-screen-container .eye-position-marker {\n    position: absolute;\n    margin: -15px;\n}\n.shooting-screen-container .eye-position-parameters {\n    position: absolute;\n    margin-top: 15px;\n    margin-left: 10px;\n    font-weight: bold;\n    font-size: 13px;\n    color: red;\n}\n.confirmation-container {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n.confirmation-container__header {\n    width: 100%;\n    padding: 10px;\n    flex: none;\n    background: whitesmoke;\n}\n.header .label {\n    font-size: 24px;\n    font-weight: bold;\n}\n.photo-list-solo {\n    display: flex;\n    text-align: center;\n    width: 100%;\n    padding: 20px;\n}\n.photo-list-solo__col {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 100%;\n    justify-content: center;\n    text-transform: uppercase;\n}\n.photo-list-solo .cropped-image {\n    margin: 10px;\n    width: 70%;\n    border-radius: 7px;\n    border: #448aff 2px solid;\n}\n.photo-list-several {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n.photo-list-several__elem {\n    display: flex;\n    flex-direction: column;\n    margin-right: 30px;\n    padding: 5px 20px 20px 20px;\n    border: 1px solid #e4e8eb;\n    text-transform: uppercase;\n    border-radius: 9px;\n}\n.photo-list-several__elem-active {\n    border: 1px solid #448aff;\n}\n.photo-list-several__elem__label {\n    display: flex;\n    padding: 10px;\n}\n.photo-list-several__elem__img {\n    height: 35vh;\n    margin-bottom: 2px;\n}\n.photo-list-several__lables {\n    display: flex;\n    flex-direction: column;\n    width: 100px;\n    height: 100%;\n    padding: 20px;\n    justify-content: space-evenly;\n    text-align: center;\n    text-transform: uppercase;\n}\n.command-line {\n    display: flex;\n    flex-direction: column;\n    width: 80px;\n    align-items: center;\n    justify-content: space-evenly;\n}\n.command-line button {\n    width: 50px;\n}\n.rotate {\n    transform: rotate(180deg);\n    transition: 0.75s;\n}\n.derotate {\n    transform: rotate(0deg);\n    transition: 0.75s;\n}\n.image-container__buttons {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    position: fixed;\n    width: 98%;\n    z-index: 500;\n    margin: 0 1%;\n}\n.image-container__buttons button {\n    margin: 10px;\n}\n.confirmation-container__content {\n    display: flex;\n    height: 100%;\n}\n.cam_left__collumn,\n.cam_right__collumn {\n    background: #f8f8fa;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 80px;\n    padding: 10px;\n    align-items: center;\n}\n.cam_right__collumn-top {\n    height: 55%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n.image-container {\n    box-sizing: border-box;\n}\n.btn-cancel {\n    width: 55px;\n    height: 55px;\n    background: #e4e8eb;\n    border-radius: 7px;\n}\n.btn-cancel-init {\n    width: fit-content;\n    height: fit-content;\n}\n.btn-cancel-init button {\n    margin: 10px;\n}\n.confirm_buttons {\n    display: flex;\n    flex-direction: column;\n    height: 150px;\n    justify-content: space-between;\n    align-items: center;\n}\n.btn-confirm {\n    width: 55px;\n    height: 55px;\n    background: #448aff;\n    border-radius: 7px;\n}\n.btn-confirm__mark {\n    color: white;\n}\n.light_icon {\n    color: #44494e;\n}\n.light_icon__active {\n    color: #448aff;\n}\n.disable_rotate {\n    color: #e4e8eb !important;\n}\n\n.image-container {\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
